// src/utils/priceFormat.js
// Professional Indian price formatting with Cormorant Garamond typography

/**
 * Format a number as Indian rupees with professional typography
 * Returns JSX-ready string parts for React rendering
 */
export function formatINR(amount, opts = {}) {
  const num = Number(amount) || 0;
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  });
}

/**
 * Calculate final price after discount
 */
export function finalPrice(sellingPrice, discountPct) {
  return Number(sellingPrice) * (1 - (Number(discountPct) || 0) / 100);
}

/**
 * Savings amount
 */
export function savingsAmount(sellingPrice, discountPct) {
  return Number(sellingPrice) * ((Number(discountPct) || 0) / 100);
}
